export function randomNumber (max, min) {
  return Math.round(Math.random() * (max - min) + min);
}


// WEBPACK FOOTER //
// ./src/helpers/helpers.js